import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

// ✅ SAME MODAL AS YOUR LEVEL COMPONENT
import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddTeam extends Component {
  state = {
    name: "",
    description: "",
    img_alt_text: "",
    meta_description: "",
    meta_key: "",
    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { name, description, img_alt_text, selectedImage , meta_description, meta_key} = this.state;

    if (!name || !selectedImage) {
      return this.setState({
        notification: true,
        message: "Name and Image are required!",
      });
    }

    const payload = {
      name,
      description,
      role_id: 1, // ✅ fixed
      image_id: selectedImage.id,
      img_alt_text,
      meta_description,
      meta_key
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(
          Constants.postUrls.createTeam,
          payload
        );

        this.setState({
          notification: true,
          message: resp.data.message || "Created successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 1500);
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      this.setState({
        notification: true,
        message:
          err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/teams" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Add Team Member
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* NAME */}
                  <Grid item sm={6}>
                    <TextField
                      label="Name"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* IMAGE PICKER */}
                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() =>
                        this.setState({ showMediaModal: true })
                      }
                    >
                      Select Image
                    </MDButton>

                    {/* PREVIEW */}
                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                          display: "block",
                          borderRadius: 6,
                        }}
                      />
                    )}
                  </Grid>

                  {/* ALT TEXT */}
                  <Grid item sm={6}>
                    <TextField
                      label="Image Alt Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                   <Grid item sm={6}>
                                                        <TextField
                                                          label="Meta Key"
                                                          name="meta_key"
                                                          value={this.state.meta_key}
                                                          onChange={this.handleInput}
                                                          fullWidth
                                                        />
                                                      </Grid>
                                    
                                                      <Grid item sm={12}>
                                                        <TextField
                                                          label="Meta Description"
                                                          name="meta_description"
                                                          multiline
                                                          rows={4}
                                                          value={this.state.meta_description}
                                                          onChange={this.handleInput}
                                                          fullWidth
                                                        />
                                                      </Grid>

                  {/* DESCRIPTION */}
                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      name="description"
                      multiline
                      rows={4}
                      value={this.state.description}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* SUBMIT */}
                  <Grid item sm={12}>
                    <MDButton
                      variant="contained"
                      color="info"
                      type="submit"
                    >
                      {this.state.loading
                        ? "Creating..."
                        : "Create"}
                    </MDButton>
                  </Grid>

                </Grid>
              </form>
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Teams"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* ✅ EXACT SAME MODAL IMPLEMENTATION */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() =>
                this.setState({ showMediaModal: false })
              }
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}